import React from 'react'

// react-icons
import { FiGrid, FiLinkedin, FiFigma, FiDatabase } from "react-icons/fi";
import { ImBlogger } from 'react-icons/im'
import { VscProject } from 'react-icons/vsc'
import {
  BsBootstrapFill,
  BsPersonLinesFill,
  BsGithub,
  BsGoogle,
  BsKanban,
} from "react-icons/bs";

import { RiContactsLine, RiReactjsLine } from 'react-icons/ri'
import {
  SiPostgresql,
  SiRubyonrails,
  SiRedux,
  SiAngellist,
  SiMedium,
  SiWebpack,
} from "react-icons/si";

import { GrGithub } from 'react-icons/gr'
import { AiFillHtml5 } from 'react-icons/ai'
import { DiCss3} from 'react-icons/di'
import { IoLogoJavascript} from 'react-icons/io'
import { FaGit } from 'react-icons/fa'

// sidebar menu functionality
const sideBarMenu = [
  {
    text: 'Home',
    icon: <FiGrid className="link-icon" />,
    url: '/',
  },
  {
    text: 'About',
    icon: <BsPersonLinesFill className="link-icon" />,
    url: '/about',
  },
  {
    text: 'Projects',
    icon: <VscProject className="link-icon" />,
    url: '/project',
  },
  {
    text: 'Blogs',
    icon: (
      <ImBlogger
        className="link-icon"
        style={{ fill: 'current', stroke: 'current' }}
      />
    ),
    url: '/blog',
  },
  {
    text: 'Contacts',
    icon: <RiContactsLine className="link-icon" />,
    url: '/contact',
  },

]
// social media icons
const socialIcons = [
  {
    icon: <GrGithub className="icon switch__color" />,
    url: "https://github.com/NATASHA-ct ",
  },
  {
    icon: <FiLinkedin className="icon switch__color" />,
    url: "https://www.linkedin.com/in/natashatatendachirombe/",
  },
  {
    icon: <SiMedium className="icon switch__color" />,
    url: "https://medium.com/@natashachirombe",
  },
  {
    icon: < SiAngellist className="icon switch__color" />,
    url: "https://angel.co/u/natasha-tatenda-chirombe",
  },
];
// skills card
const skillSet = [
  {
    icon: <FaGit className="skills-icon switch__color" />,
    spanText: "GIT",
    url: "https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/GitHub",
  },
  {
    icon: <BsGithub className="skills-icon switch__color" />,
    spanText: "GITHUB",
    url: "https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/GitHub",
  },
  {
    icon: <BsBootstrapFill className="skills-icon switch__color" />,
    spanText: "BOOTSTRAP",
    url: "https://getbootstrap.com/docs/5.3/getting-started/introduction/",
  },
  {
    icon: <IoLogoJavascript className="skills-icon switch__color" />,
    spanText: "JAVASCRIPT",
    url: "https://developer.mozilla.org/en-US/docs/Learn/JavaScript",
  },
  {
    icon: <RiReactjsLine className="skills-icon switch__color" />,
    spanText: "REACT JS",
    url: "https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Client-side_JavaScript_frameworks/React_getting_started",
  },
  {
    icon: <SiRedux className="skills-icon switch__color" />,
    spanText: "Redux",
    url: "https://redux.js.org/introduction/getting-started",
  },
  {
    icon: <SiWebpack className="skills-icon switch__color" />,
    spanText: "WEBPACK",
    url: "https://webpack.js.org/",
  },
  {
    icon: <BsKanban className="skills-icon switch__color" />,
    spanText: "KANBAN",
    url: "https://github.com/kanboard/kanboard",
  },
  {
    icon: <FiDatabase className="skills-icon switch__color" />,
    spanText: "Databases",
    url: "",
  },
  {
    icon: <SiRubyonrails className="skills-icon switch__color" />,
    spanText: "Ruby on Rails",
    url: "https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Express",
  },

  {
    icon: <SiPostgresql className="skills-icon switch__color" />,
    spanText: "Postgresql",
    url: "https://www.postgresql.org/",
  },
  {
    icon: <AiFillHtml5 className="skills-icon switch__color" />,
    spanText: "HTML",
    url: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    icon: <DiCss3 className="skills-icon switch__color" />,
    spanText: "CSS",
    url: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    icon: <FiFigma className="skills-icon switch__color" />,
    spanText: "Figma",
    url: "https://figma.com",
  },
  {
    icon: <BsGoogle className="skills-icon switch__color" />,
    spanText: "Googling",
    url: "https://google.com",
  },
];

export { sideBarMenu, socialIcons, skillSet }
